import { Slide } from "react-toastify";


export const toastCfg = {
    position: "top-right",
    autoClose: 2200,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    transition: Slide,
    newestOnTop: true,
  };